import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30000,
});

const imageClient = axios.create({
  baseURL: process.env.REACT_APP_IMAGE_BASE_URL,
  timeout: 30000,
});

apiClient.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    config.headers["X-Api-Key"] = process.env.REACT_APP_X_API_KEY;
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

imageClient.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "image/png";
    config.responseType = "arraybuffer";
    return config;
  },
  (error) => Promise.reject(error)
);

export { imageClient };

export default apiClient;
